// modal potwierdzający usunięcie procesu

import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import { Modal, Button } from 'components/controls';

import styles from 'theme/components/containers/DeleteProcessModal/DeleteProcessModal.module.scss';

interface IDeleteProcessModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  processName: string;
  isLoading?: boolean;
}

const DeleteProcessModal: FC<IDeleteProcessModalProps> = ({
  open,
  onClose,
  onConfirm,
  processName,
  isLoading = false
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} title={t('Potwierdzenie usunięcia')}>
      <div
        className={classnames(
          styles.content,
          'StylePath-Components-Containers-DeleteProcessModal'
        )}>
        <div className={styles.message}>
          {t('Czy na pewno chcesz usunąć proces')} <strong>&quot;{processName}&quot;</strong>?
        </div>
        <div className={styles.warning}>
          {t('Ta operacja jest nieodwracalna.')}
        </div>
        <div className={styles.actions}>
          <Button onClick={onClose} color="gray" ghost disabled={isLoading}>
            {t('Anuluj')}
          </Button>
          <Button onClick={onConfirm} color="danger" loading={isLoading}>
            {t('Usuń')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteProcessModal;
